import React from 'react'
import { View } from 'react-native'

import styles from './styles'
import { HGText } from '../../components/HGUI'

type Props = {
  text?: string
}

const Disclaimer = (props: Props) => {
  const { text } = props

  return (
    <View style={styles.disclaimerContainer}>
      <HGText style={styles.disclaimerText}>{text}</HGText>
    </View>
  )
}

Disclaimer.defaultProps = {
  text: 'Die Fallverantwortung bleibt beim Nutzer dieser App.',
}

Disclaimer.propTypes = {}

export default Disclaimer
